(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    const form = document.querySelector("#snd-add-to-cart-form");
    if (!form) return;

    const picker = form.querySelector("[data-variant-picker]");
    const idInput = form.querySelector("[data-variant-id]");
    const jsonEl = document.getElementById("SND-Variants-JSON");
    if (!picker || !idInput || !jsonEl) return;

    let variants = [];
    try {
      variants = JSON.parse(jsonEl.textContent || "[]");
    } catch (e) {
      console.error("[SND Variants] JSON parse failed", e);
      return;
    }

    function getSelectedOptions() {
      // Radios are grouped by name, so read checked per option-index
      const radios = picker.querySelectorAll('input[type="radio"][data-option-index]');
      const indexes = [...new Set([...radios].map(r => Number(r.dataset.optionIndex)))].sort((a, b) => a - b);

      return indexes.map(idx => {
        const checked = picker.querySelector(`input[type="radio"][data-option-index="${idx}"]:checked`);
        return checked ? checked.value : null;
      });
    }

    function findVariant(selectedOptions) {
      if (!selectedOptions.length || selectedOptions.includes(null)) return null;
      return variants.find(v => Array.isArray(v.options) && v.options.every((opt, i) => opt === selectedOptions[i]));
    }

    // Disable pills that map to unavailable variants (aka qty 0)
    function updateOptionAvailability() {
      const radios = picker.querySelectorAll('input[type="radio"][data-option-index]');

      radios.forEach(radio => {
        const optionIndex = Number(radio.dataset.optionIndex);
        const value = radio.value;

        // Start from current selection
        const selected = getSelectedOptions();

        // Pretend this pill is selected
        selected[optionIndex] = value;

        // Find the variant for that "would-be" selection
        const matchingVariant = findVariant(selected);

        const label = radio.closest(".snd-variant-pill");

        // If no matching variant OR variant exists but not available -> disable it
        if (!matchingVariant || !matchingVariant.available) {
          radio.disabled = true;

          // If it was selected, unselect it so user can't be stuck on an OOS option
          if (radio.checked) radio.checked = false;

          if (label) label.classList.add("is-disabled");
        } else {
          radio.disabled = false;
          if (label) label.classList.remove("is-disabled");
        }
      });
    }

    function syncVariant() {
      // First update which pills are selectable based on current selection
      updateOptionAvailability();

      const selected = getSelectedOptions();
      const variant = findVariant(selected);

      // If selection doesn't resolve to a variant, stop here (keeps pills updated though)
      if (!variant) return;

      // Sync variant id input (so Shopify sees it)
      idInput.value = variant.id;

 
   // Toggle ATC
const atcBtn = form.querySelector(".snd-atc-btn");
if (atcBtn) {
  if (variant.available) {
    atcBtn.removeAttribute("disabled");
    atcBtn.textContent = atcBtn.dataset.defaultText || "ADD TO CART";
    atcBtn.classList.remove("snd-atc-btn--soldout");
  } else {
    atcBtn.setAttribute("disabled", "disabled");
    atcBtn.textContent = "SOLD OUT";
    atcBtn.classList.add("snd-atc-btn--soldout");
  }
}

      // Update price UI
      const priceWrapper = document.querySelector(".snd-price-wrapper");
      if (priceWrapper && variant.price != null) {
        const priceEl = priceWrapper.querySelector(".snd-price");
        const comparePriceEl = priceWrapper.querySelector(".snd-compare-price");
        const saveBadge = priceWrapper.querySelector(".snd-save-badge");

        // Format price (variant.price is in cents)
        const formattedPrice = Shopify.formatMoney(variant.price, "£{{amount}}");
        if (priceEl) priceEl.textContent = formattedPrice;

        // Compare-at handling
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const formattedCompare = Shopify.formatMoney(variant.compare_at_price, "£{{amount}}");
          if (comparePriceEl) {
            comparePriceEl.textContent = formattedCompare;
            comparePriceEl.style.display = "";
          }

          // Savings %
          const savePercent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          if (saveBadge) {
            saveBadge.textContent = `SAVE ${savePercent}%`;
            saveBadge.style.display = "";
          }
        } else {
          if (comparePriceEl) comparePriceEl.style.display = "none";
          if (saveBadge) saveBadge.style.display = "none";
        }
      }
    }

    // Update on change
    picker.addEventListener("change", function () {
      syncVariant();

      // After disabling things, you might end up with no selection for an option.
      // If that happens, try to auto-select the first enabled radio per option group.
      const radios = picker.querySelectorAll('input[type="radio"][data-option-index]');
      const indexes = [...new Set([...radios].map(r => Number(r.dataset.optionIndex)))];

      indexes.forEach(idx => {
        const checked = picker.querySelector(`input[type="radio"][data-option-index="${idx}"]:checked`);
        if (checked) return;

        const firstEnabled = picker.querySelector(`input[type="radio"][data-option-index="${idx}"]:not(:disabled)`);
        if (firstEnabled) firstEnabled.checked = true;
      });

      // Re-sync after any auto-correction
      syncVariant();
    });

    // Update right before submit (paranoia, but correct)
    form.addEventListener("submit", function () {
      syncVariant();
    });

    // Initial sync on load
    syncVariant();
  });
})();




// // Optimized version - same functionality, better performance

// (function() {
//   'use strict';
  
//   // Cache DOM queries
//   let mediaSlider, mediaSlides, thumbnails, items, cartForm;
//   let currentSlide = 0;
//   let autoSlideInterval;
//   const SLIDE_DURATION = 5000;

//   // Slider functionality
//   function initSlider() {
//     mediaSlider = document.querySelector('.media-slider');
//     mediaSlides = document.querySelectorAll('.media-slide');
//     thumbnails = document.querySelectorAll('.thumbnail-vertical');
    
//     if (!mediaSlides.length) return;

//     currentSlide = 0;

//     // Use event delegation for thumbnails
//     const thumbContainer = thumbnails[0]?.parentElement;
//     if (thumbContainer) {
//       thumbContainer.addEventListener('click', (e) => {
//         const thumb = e.target.closest('.thumbnail-vertical');
//         if (thumb) {
//           const index = Array.from(thumbnails).indexOf(thumb);
//           if (index !== -1) {
//             goToSlide(index);
//             resetAutoSlide();
//           }
//         }
//       });
//     }

//     // Wait for images to load before starting auto-slide
//     waitForImagesToLoad().then(startAutoSlide);
//     setupVideoHandlers();
//     setupNavigation();
//   }

//   function waitForImagesToLoad() {
//     const images = mediaSlider?.querySelectorAll('img') || [];
//     if (!images.length) return Promise.resolve();

//     const imagePromises = Array.from(images).map(img => {
//       if (img.complete) return Promise.resolve();
//       return new Promise(resolve => {
//         img.addEventListener('load', resolve, { once: true });
//         img.addEventListener('error', resolve, { once: true }); // Resolve even on error
//       });
//     });

//     // Fallback timeout in case images take too long
//     const timeout = new Promise(resolve => setTimeout(resolve, 3000));
    
//     return Promise.race([
//       Promise.all(imagePromises),
//       timeout
//     ]);
//   }

//   function goToSlide(index) {
//     if (index < 0) index = mediaSlides.length - 1;
//     if (index >= mediaSlides.length) index = 0;

//     currentSlide = index;

//     // Batch DOM updates
//     requestAnimationFrame(() => {
//       for (let i = 0; i < mediaSlides.length; i++) {
//         const isActive = i === index;
//         mediaSlides[i].classList.toggle('active', isActive);
//         thumbnails[i].classList.toggle('active', isActive);
//       }

//       mediaSlider.scrollTo({
//         left: mediaSlides[index].offsetLeft,
//         behavior: 'smooth'
//       });
//     });
//   }

//   function nextSlide() {
//     goToSlide(currentSlide + 1);
//   }

//   function prevSlide() {
//     goToSlide(currentSlide - 1);
//   }

//   function startAutoSlide() {
//     autoSlideInterval = setInterval(nextSlide, SLIDE_DURATION);
//   }

//   function resetAutoSlide() {
//     clearInterval(autoSlideInterval);
//     startAutoSlide();
//   }

//   function setupVideoHandlers() {
//     // Event delegation for videos
//     mediaSlider?.addEventListener('play', (e) => {
//       if (e.target.tagName === 'VIDEO') {
//         clearInterval(autoSlideInterval);
//       }
//     }, true);

//     mediaSlider?.addEventListener('pause', (e) => {
//       if (e.target.tagName === 'VIDEO') {
//         resetAutoSlide();
//       }
//     }, true);

//     mediaSlider?.addEventListener('ended', (e) => {
//       if (e.target.tagName === 'VIDEO') {
//         resetAutoSlide();
//       }
//     }, true);
//   }

//   function setupNavigation() {
//     const prevBtn = document.querySelector('.ms-product-slider-prev');
//     const nextBtn = document.querySelector('.ms-product-slider-next');

//     if (prevBtn) {
//       prevBtn.addEventListener('click', () => {
//         prevSlide();
//         resetAutoSlide();
//       });
//     }
//     if (nextBtn) {
//       nextBtn.addEventListener('click', () => {
//         nextSlide();
//         resetAutoSlide();
//       });
//     }

//     // Keyboard navigation
//     document.addEventListener('keydown', (e) => {
//       if (e.key === 'ArrowLeft') {
//         prevSlide();
//         resetAutoSlide();
//       } else if (e.key === 'ArrowRight') {
//         nextSlide();
//         resetAutoSlide();
//       }
//     });
//   }

//   // Accordion functionality
//   function initAccordion() {
//     items = document.querySelectorAll('.snd-accordion-item');
//     if (!items.length) return;

//     // items[0].classList.add('active');

//     // Event delegation for accordion
//     document.addEventListener('click', (e) => {
//       const header = e.target.closest('.snd-accordion-header');
//       if (!header) return;

//       const item = header.parentElement;
//       const isOpen = item.classList.contains('active');

//       // Close all
//       items.forEach(i => i.classList.remove('active'));

//       // Open clicked (if it was closed)
//       if (!isOpen) {
//         item.classList.add('active');
//       }
//     });
//   }

//   // AJAX Add to Cart
//   function initCartForm() {
//     cartForm = document.getElementById('snd-add-to-cart-form');
//     if (!cartForm) return;

//     cartForm.addEventListener('submit', function(e) {
//       e.preventDefault();
      
//       fetch('/cart/add.js', {
//         method: 'POST',
//         body: new FormData(this)
//       })
//       .then(res => res.json())
//       .then(data => {
//         document.dispatchEvent(new Event('cart:updated'));
//         window.location.href = '/cart';
//       })
//       .catch(err => console.error('Add to cart error:', err));
//     });
//   }

//   // Initialize all on DOM ready
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   function init() {
//     initSlider();
//     initAccordion();
//     initCartForm();
//   }
// })();


// Optimized version - same functionality, better performance
(function () {
  'use strict';

  // Cache DOM queries
  let mediaSlider, mediaSlides, thumbnails, items, cartForm;
  let currentSlide = 0;
  let autoSlideInterval;
  const SLIDE_DURATION = 5000;

  // Slider functionality
  function initSlider() {
    mediaSlider = document.querySelector('.media-slider');
    mediaSlides = document.querySelectorAll('.media-slide');
    thumbnails = document.querySelectorAll('.thumbnail-vertical');

    if (!mediaSlides.length || !mediaSlider) return;

    currentSlide = 0;

    // Use event delegation for thumbnails
    const thumbContainer = thumbnails[0]?.parentElement;
    if (thumbContainer) {
      thumbContainer.addEventListener('click', (e) => {
        const thumb = e.target.closest('.thumbnail-vertical');
        if (!thumb) return;

        const index = Array.from(thumbnails).indexOf(thumb);
        if (index !== -1) {
          goToSlide(index);
          resetAutoSlide();
        }
      });
    }

    // Wait for images to load before starting auto-slide
    waitForImagesToLoad().then(startAutoSlide);
    setupVideoHandlers();
    setupNavigation();
  }

  function waitForImagesToLoad() {
    const images = mediaSlider?.querySelectorAll('img') || [];
    if (!images.length) return Promise.resolve();

    const imagePromises = Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve();
      return new Promise((resolve) => {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true }); // Resolve even on error
      });
    });

    // Fallback timeout in case images take too long
    const timeout = new Promise((resolve) => setTimeout(resolve, 3000));

    return Promise.race([Promise.all(imagePromises), timeout]);
  }

  function goToSlide(index) {
    if (!mediaSlides.length || !thumbnails.length) return;

    if (index < 0) index = mediaSlides.length - 1;
    if (index >= mediaSlides.length) index = 0;

    currentSlide = index;

    requestAnimationFrame(() => {
      for (let i = 0; i < mediaSlides.length; i++) {
        const isActive = i === index;
        mediaSlides[i].classList.toggle('active', isActive);

        // Guard in case thumbnails count differs
        if (thumbnails[i]) thumbnails[i].classList.toggle('active', isActive);
      }

      mediaSlider.scrollTo({
        left: mediaSlides[index].offsetLeft,
        behavior: 'smooth',
      });
    });
  }

  function nextSlide() {
    goToSlide(currentSlide + 1);
  }

  function prevSlide() {
    goToSlide(currentSlide - 1);
  }

  function startAutoSlide() {
    clearInterval(autoSlideInterval);
    autoSlideInterval = setInterval(nextSlide, SLIDE_DURATION);
  }

  function resetAutoSlide() {
    clearInterval(autoSlideInterval);
    startAutoSlide();
  }

  function setupVideoHandlers() {
    // Event delegation for videos
    mediaSlider?.addEventListener(
      'play',
      (e) => {
        if (e.target && e.target.tagName === 'VIDEO') {
          clearInterval(autoSlideInterval);
        }
      },
      true
    );

    mediaSlider?.addEventListener(
      'pause',
      (e) => {
        if (e.target && e.target.tagName === 'VIDEO') {
          resetAutoSlide();
        }
      },
      true
    );

    mediaSlider?.addEventListener(
      'ended',
      (e) => {
        if (e.target && e.target.tagName === 'VIDEO') {
          resetAutoSlide();
        }
      },
      true
    );
  }

  function setupNavigation() {
    const prevBtn = document.querySelector('.ms-product-slider-prev');
    const nextBtn = document.querySelector('.ms-product-slider-next');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevSlide();
        resetAutoSlide();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextSlide();
        resetAutoSlide();
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevSlide();
        resetAutoSlide();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
        resetAutoSlide();
      }
    });
  }

  // Accordion functionality
  function initAccordion() {
    items = document.querySelectorAll('.snd-accordion-item');
    if (!items.length) return;

    // ✅ No default open
    // items[0].classList.add('active');

    // Event delegation for accordion
    document.addEventListener('click', (e) => {
      const header = e.target.closest('.snd-accordion-header');
      if (!header) return;

      const item = header.parentElement;
      const isOpen = item.classList.contains('active');

      // Close all
      items.forEach((i) => i.classList.remove('active'));

      // Open clicked (if it was closed)
      if (!isOpen) item.classList.add('active');
    });
  }

  // ✅ Quantity selector (+ / -)
  function initQtySelector() {
    document.addEventListener('click', (e) => {
      const minus = e.target.closest('.snd-qty-minus');
      const plus = e.target.closest('.snd-qty-plus');
      if (!minus && !plus) return;

      const wrap = e.target.closest('.snd-qty');
      const input = wrap?.querySelector('.snd-qty-input');
      if (!input) return;

      const current = parseInt(input.value || '1', 10);
      const min = parseInt(input.getAttribute('min') || '1', 10);

      if (plus) input.value = current + 1;
      if (minus) input.value = Math.max(min, current - 1);

      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }


  // Thumbnail strip scroll arrows
// Thumbnail strip scroll arrows + drag scroll
  function initThumbnailArrows() {
    const strip = document.querySelector('.vertical-thumbnail');
    const prevBtn = document.querySelector('.thumb-prev');
    const nextBtn = document.querySelector('.thumb-next');
    if (!strip || !prevBtn || !nextBtn) return;

    const scrollAmount = 130;

    // ── Arrow visibility ──
    function updateArrowVisibility() {
      const atStart = strip.scrollLeft <= 1;
      const atEnd = strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - 1;
      prevBtn.classList.toggle('hidden', atStart);
      nextBtn.classList.toggle('hidden', atEnd);
    }

    prevBtn.addEventListener('click', () => {
      strip.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      strip.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    strip.addEventListener('scroll', updateArrowVisibility);
    updateArrowVisibility();
    window.addEventListener('load', updateArrowVisibility);
    window.addEventListener('resize', updateArrowVisibility);

    // ── Drag scroll ──
    let isDragging = false;
    let startX = 0;
    let scrollLeftAtStart = 0;

    // Mouse events
    strip.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX;
      scrollLeftAtStart = strip.scrollLeft;
      strip.classList.add('dragging');
      e.preventDefault();
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const diff = e.pageX - startX;
      strip.scrollLeft = scrollLeftAtStart - diff;
      updateArrowVisibility();
    });

    window.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      strip.classList.remove('dragging');
    });

    // Touch events (mobile)
    strip.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].pageX;
      scrollLeftAtStart = strip.scrollLeft;
      strip.classList.add('dragging');
    }, { passive: true });

    strip.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const diff = e.touches[0].pageX - startX;
      strip.scrollLeft = scrollLeftAtStart - diff;
      updateArrowVisibility();
    }, { passive: true });

    strip.addEventListener('touchend', () => {
      isDragging = false;
      strip.classList.remove('dragging');
    });
  }

  // AJAX Add to Cart (respects quantity automatically)
  function initCartForm() {
    cartForm = document.getElementById('snd-add-to-cart-form');
    if (!cartForm) return;

    cartForm.addEventListener('submit', function (e) {
      e.preventDefault();

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(this),
      })
        .then((res) => res.json())
        .then(() => {
          document.dispatchEvent(new Event('cart:updated'));
          window.location.href = '/cart';
        })
        .catch((err) => console.error('Add to cart error:', err));
    });
  }

function initReviewScroll() {
  const ratingWrapper = document.querySelector('.product-rating-wrapper');
  const reviewSection = document.querySelector('#looxReviews, .loox-reviews');

  if (!ratingWrapper || !reviewSection) return;

  const HEADER_OFFSET = 90; 

  ratingWrapper.style.cursor = "pointer";

  ratingWrapper.addEventListener('click', function (e) {
    e.preventDefault();

    const y = reviewSection.offsetTop - HEADER_OFFSET;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  });
}

  // Initialize all on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initSlider();
    initAccordion();
    initQtySelector(); // ✅ added
    initThumbnailArrows();
    initCartForm();
    initReviewScroll();
  }
})();
